module.exports = "/assets/site/images/termeszetbarat.jpg?6d031ec0f590a735ff4e9842859ff73a";